import useSWR from 'swr'
import API from '../../utils/api'
import { useToken } from 'app/hooks'
import {useEffect, useState} from "react";
import useSound from 'use-sound';
import messageSound from '../assets/MessageAlarm.mp3';
import {message} from "antd";
import * as workerTimers from 'worker-timers';

const KEY = '/dashboard/noti?unread=1&page=1&maxData=99999999'


export function useNotiInfo() {
	const { data: token } = useToken()
	const [refreshIndex, setRefreshIndex] = useState(0);
	const [play] = useSound(messageSound);
	const [isPlaying, setIsPlaying] = useState(false);
	const [messageSwitch, setMessageSwitch] = useState(() => {
		const saved = localStorage.getItem('messageSwitch');
		return saved !== null ? JSON.parse(saved) : true;
	});

	const { data, mutate } = useSWR<any>(
		[KEY, refreshIndex] ,
		async () => {
			const response = await API.get(KEY, token + '', {})
			// swrData = response.result?.result

			return response.result?.result
		},
		{
			refreshInterval: 30000
		}
	)

	useEffect(() => {
		localStorage.setItem('messageSwitch', JSON.stringify(messageSwitch));
	}, [messageSwitch]);

	// console.log(data)

	if ((data?.totalCount > 0) && (data?.list.length > 0) && !isPlaying && messageSwitch) {

		setIsPlaying(true);
		play();
		message.info('새로운 메세지가 도착하였습니다.');

		workerTimers.setTimeout(() => {
			setIsPlaying(false);
		}, 30000);
	}


	// useEffect(() => {
	// 	const timer = workerTimers.setInterval(() => {
	// 		setRefreshIndex(prev => prev + 1);
	// 	}, 30000);
	//
	// 	return () => workerTimers.clearInterval(timer);
	// }, []);

	return {
		notiInfo: data,
		notiInfoMutate:mutate,
		messageSwitch: messageSwitch,
		setMessageSwitch
	}
}